var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportationX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 21C8.00001 20.4477 8.44773 20 9.00001 20H15C15.5523 20 16 20.4477 16 21C16 21.5523 15.5523 22 15 22H9.00001C8.44773 22 8.00001 21.5523 8.00001 21Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 1C6.34316 1 5.00001 2.34315 5.00001 4V16C5.00001 16.9095 5.40477 17.7245 6.04398 18.2747L3.40001 21.8C3.06864 22.2418 3.15818 22.8686 3.60001 23.2C4.04184 23.5314 4.66864 23.4418 5.00001 23L8.00001 19H16L19 23C19.3314 23.4418 19.9582 23.5314 20.4 23.2C20.8418 22.8686 20.9314 22.2418 20.6 21.8L17.956 18.2747C18.5953 17.7245 19 16.9095 19 16V4C19 2.34315 17.6569 1 16 1H8.00001ZM8.00001 3C7.44773 3 7.00001 3.44772 7.00001 4V16C7.00001 16.5523 7.44773 17 8.00001 17H16C16.5523 17 17 16.5523 17 16V4C17 3.44772 16.5523 3 16 3H8.00001Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 14.5523 9.55229 15 9.00001 15C8.44772 15 8.00001 14.5523 8.00001 14C8.00001 13.4477 8.44772 13 9.00001 13C9.55229 13 10 13.4477 10 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14C16 14.5523 15.5523 15 15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13C15.5523 13 16 13.4477 16 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 6C8.00001 5.44772 8.44772 5 9.00001 5H15C15.5523 5 16 5.44772 16 6V10C16 10.5523 15.5523 11 15 11H9.00001C8.44772 11 8.00001 10.5523 8.00001 10V6Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportationX2);
export default __webpack_public_path__ + "static/media/TransportationX2.339ae32ea30bb8579150ed1e5b5bc2da.svg";
export { ForwardRef as ReactComponent };